import { render, staticRenderFns } from "./PolicyListPage.vue?vue&type=template&id=52e5bab3&"
import script from "./PolicyListPage.vue?vue&type=script&lang=js&"
export * from "./PolicyListPage.vue?vue&type=script&lang=js&"
import style0 from "./PolicyListPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports